import SynchronizeSatInvoices from './SynchronizeSatInvoices';
export default SynchronizeSatInvoices;
